import React from 'react';

export default function StatCard({ label, value, sub, variant }) {
  return (
    <div className={`stat-card${variant ? ` ${variant}` : ''}`}>
      <div className="label">{label}</div>
      <div className="value">{value ?? '—'}</div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  );
}
